import { css } from '../../../styled-components';
import { mgbStyles } from './button.styles.mgb';
export const micasaStyles = css`
  ${mgbStyles}

  font-weight: ${({
  theme: {
    fonts
  }
}) => fonts.weights.semiBold};
`;